<template>
  <div class="procurementPage" v-if="!this.showLoad">
    <div class="wrap">
      <div class="goodsBox">
        <div class="goodsLists">
          <div
            class="goodsItem"
            v-for="(item, index) in goodsList"
            :key="item.typeCode"
          >
            <van-cell-group class="baseNone baseSalary">
              <van-field
                v-model="item.materialName"
                label="物资名称："
                :required="editType"
                :readonly="!editType"
                class="ggInput"
                input-align="right"
                :placeholder="editType ? '请输入...  ' : ''"
              />
            </van-cell-group>
            <van-cell-group class="baseNone baseSalary">
              <van-field
                v-model="item.modelNumber"
                clearable
                :required="editType"
                class="ggInput"
                input-align="right"
                label="型号规格："
                :placeholder="editType ? '请输入...  ' : ''"
              />
            </van-cell-group>
            <van-cell-group class="baseNone baseSalary">
              <van-field
                v-model="item.unit"
                clearable
                :readonly="!editType"
                :required="editType"
                label="单位："
                class="ggInput"
                input-align="right"
                :placeholder="editType ? '请输入...  ' : ''"
              />
            </van-cell-group>
            <van-cell-group class="baseNone baseSalary">
              <van-field
                v-model="item.purchaseAmount"
                clearable
                type="digit"
                :readonly="!editType"
                :required="editType"
                label="数量："
                class="ggInput"
                input-align="right"
                :placeholder="editType ? '请输入...  ' : ''"
              />
            </van-cell-group>
            <van-cell-group class="baseNone baseSalary">
              <van-field
                v-model="item.price"
                clearable
                type="number"
                :readonly="!editType"
                :required="editType"
                label="单价(元)"
                class="ggInput"
                input-align="right"
                :placeholder="editType ? '请输入...  ' : ''"
              />
            </van-cell-group>
            <van-cell-group class="baseNone baseSalary">
              <van-field
                v-model="item.purchaseDate"
                readonly
                :is-link="editType"
                @click="deliveryPicker(index)"
                label="交付时间"
                input-align="right"
                :placeholder="editType ? '请选择' : ''"
              />
            </van-cell-group>
            <div class="delect" v-if="goodsList.length > 1 && editType">
              <van-icon name="cross" @click="delect(index)" />
            </div>
          </div>
        </div>
        <div class="addBtn" v-if="editType">
          <van-button
            icon="plus"
            type="primary"
            class="addClaim"
            size="small"
            @click="addClaim"
            >添加采购单品</van-button
          >
        </div>
      </div>

      <van-cell-group class="baseNone baseSalary beizhu">
        <van-field
          v-model="propertyData.reason"
          label="采购原因："
          :required="editType"
          rows="1"
          autosize
          input-align="right"
          type="textarea"
          :readonly="!editType"
          :placeholder="editType ? '请输入...  ' : ''"
        />
      </van-cell-group>
      <!-- <p>{{totalMoney}}</p> -->
      <van-cell-group class="baseNone baseSalary beizhu">
        <van-field
          v-model="propertyData.remarks"
          label="备注："
          rows="1"
          autosize
          input-align="right"
          type="textarea"
          :readonly="!editType"
          :placeholder="editType ? '请输入...  ' : ''"
        />
      </van-cell-group>
      <!-- 审批流程 -->
      <div
        class="approveList"
        v-if="this.mode != 'add' && propertyData.verifyStatus != 'hold'"
      >
        <audit-list :applicantData="propertyData"></audit-list>
      </div>

      <!-- 流程图 -->
      <div
        class="flowList"
        v-if="this.mode != 'add' && propertyData.verifyStatus != 'hold'"
      >
        <flow-staff :applicantData="propertyData"></flow-staff>
        <flow-list :workflowCode="propertyData.workflowCode"></flow-list>
      </div>
      <!-- 审批 -->
      <van-popup
        v-model="verifyPageType"
        closeable
        round
        close-icon="close"
        position="bottom"
        class="verifyPage"
      >
        <verify-main
          :applicantData="propertyData"
          @changeVerifyType="setVerifyType"
        ></verify-main>
      </van-popup>
    </div>
    <!-- 保存按钮 -->
    <!-- 新增状态下提交 -->
    <div class="btnBox" v-if="mode == 'add'">
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="checkInput"
        class="btn"
        >提交</van-button
      >
    </div>
    <!-- 编辑状态下 -->
    <template v-else-if="editType && mode != 'verify'">
      <div
        class="btnBox editBtnbox clearfix"
        v-if="propertyData.verifyStatus == 'hold'"
      >
        <van-row class="dis_flex justy_space btnGroup">
          <van-col span="10">
            <van-button
              type="danger"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="delApply"
              class="btn"
              >删除</van-button
            >
          </van-col>
          <van-col span="4"></van-col>
          <van-col span="10">
            <van-button
              type="info"
              :loading="btnLoading"
              :loading-text="loadingText"
              @click="checkInput"
              class="btn"
              >保存</van-button
            >
          </van-col>
        </van-row>
      </div>
      <div
        class="btnBox denyBtn clearfix"
        v-if="propertyData.verifyStatus == 'deny'"
      >
        <van-button
          type="info"
          :loading="btnLoading"
          :loading-text="loadingText"
          @click="checkInput"
          class="btn"
          >再次提交</van-button
        >
      </div>
    </template>
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        propertyData.verifyStatus == 'pending' &&
        mode != 'verify' &&
        sendType != '1'
      "
    >
      <van-button
        type="info"
        :loading="btnLoading"
        :loading-text="loadingText"
        @click="delApply"
        class="btn"
        >撤回修改</van-button
      >
    </div>
    <!-- 审批按钮 -->
    <div
      class="btnBox denyBtn clearfix"
      v-if="
        (mode == 'verify' &&
          propertyData.verifyStatus == 'pending' &&
          verifyType == '1') ||
        (mode == 'verify' &&
          propertyData.verifyStatus == 'doing' &&
          verifyType == '1')
      "
    >
      <van-button type="info" @click="verifyPage">{{
        verifyPageText
      }}</van-button>
    </div>
    <refresh-page v-if="refreshPage" />

    <!-- 弹出框 -->
    <!-- 时间控件 -->
    <van-popup v-model="showTimePicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        @cancel="showTimePicker = false"
        @confirm="onTimeConfirm"
        :min-date="minDate"
      />
    </van-popup>
  </div>
</template>
<script>
/* eslint-disable */
import newApi from "lodash";
import { mapMutations, mapState } from "vuex";
const refreshPage = () => import("@/components/common/refreshPage");
const flowList = () => import("@/components/common/flowList");
const auditList = () => import("@/components/common/auditList");
const verifyMain = () => import("@/components/common/verifyMain");
const flowStaff = () => import("@/components/common/flowStaff");
import {
  dateFormat,
  dateTimeFormat,
  getDictList,
  intervalTime,
  diffMonth,
  isEdit,
  getCurData,
} from "@/utils/common";
import {
  getDeviceType,
  closePage,
  is_wei,
} from "@/common/getDeviceType/getDeviceType";
export default {
  name: "procurementManage",
  components: {
    refreshPage,
    auditList,
    flowList,
    verifyMain,
    flowStaff,
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      mode: "add",
      editType: false, //是否可以编辑
      rkType: "", //入库状态
      goodsList: [
        {
          id: "", //物资小项id
          materialName: "", //物资名称
          modelNumber: "", //物资规格型号
          price: "", //采购价格
          purchaseAmount: "", //采购数量
          purchaseDate: "", //交付时间
          unit: "", //单位
        },
      ],
      propertyData: {
        itemList: [],
        allMoney: "", //动态计算采购得物资价格
        reason: "", //采购原因
        remarks: "", // 备注
        verifyStatus: "hold",
      },

      refreshPage: false, // 网络请求失败时显示
      clientType: getDeviceType(), //手机类型
      addType: false, //防止高频点击
      showTimePicker: false, //时间控件
      currentDate: new Date(), //当前时间
      minDate: new Date(getCurData()),
      checkIndex: "", // 获取证书发放和到期时间
      verifyPageType: false, //审批弹框,默认不显示
      verifyPageText: "",
      verifyType: "", //判断是否已审核
      btnLoading: false, //btn是否为加载状态
      loadingText: "操作中...", //	btn加载状态提示文字
      sendType: "", //判断是否在抄送列表
    };
  },
  mounted() {
    if (is_wei()) {
      document.title = "采购申请";
    }
    this.commonId = this.$route.query.commonId; //申请Id
    this.mode = this.$route.query.commonType; // add:新增 edit:查看/编辑
    this.verifyType = this.$route.query.verifyType; //审核状态是否已审核
    this.sendType = this.$route.query.sendType; // 1：在抄送列表
    this.rkType = this.$route.query.rkType; //入库状态
    this.editType = this.mode == "add" ? true : false;
    window.editPage = this.editPage; //调用编辑
    window.verifyPage = this.verifyPage; //审批页面
    window.rkPage = this.getJumpUrl; //跳转新增入库
    this.$nextTick(() => {
      this.verifyPageText = this.verifyType == "1" ? "审批" : "查看";
      if (this.mode == "edit" || this.mode == "verify" || this.mode == "view") {
        this.initPage();
      } else {
        this.setShowLoad(false);
      }
    });
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    //微信状态下 监测已审核  修改状态
    setVerifyType(data) {
      this.verifyPageType = false;
      if (data) {
        this.verifyType = "2";
      }
    },
    addClaim() {
      //添加物资小项
      this.goodsList.push({
        id: "", //物资小项id
        materialName: "", //物资名称
        modelNumber: "", //物资规格型号
        purchaseAmount: "", //采购数量
        deliveryTime: "", //交付时间
        unit: "", //单位
        unitPrice: "", //单价(元)
      });
    },
    initPage() {
      this.setShowLoad(false);
      let _this = this;
      _this.$api.material.procurementManage
        .detailsProcurement(_this.commonId)
        .then((res) => {
          if (res.code == "1" && res.data != null) {
            _this.propertyData = newApi.assign(
              {},
              _this.propertyData,
              res.data
            );

            if (_this.propertyData.remarks == null) {
              this.$set(_this.propertyData, "remarks", "");
            }
            _this.goodsList = _this.propertyData.itemList;
            _this.goodsList.forEach((item) => {
              for (let key in item) {
                if (item[key] == null) {
                  item[key] = "";
                }
              }
            });

            // let type = isEdit(_this.propertyData.verifyStatus, _this.mode);
            if (
              (_this.propertyData.verifyStatus == "hold" ||
                _this.propertyData.verifyStatus == "deny") &&
              _this.mode == "edit"
            ) {
              if (_this.clientType == "android") {
                window.android.getInfo(102);
              } else {
                window.webkit.messageHandlers.showEdit.postMessage(null);
              }
            }

            if (
              _this.rkType == null ||
              _this.rkType == undefined ||
              _this.rkType == "undefined" ||
              _this.rkType == "null"
            ) {
              console.log(_this.rkType);
            } else {
              if (
                (_this.propertyData.verifyStatus == "pass" &&
                  _this.rkType == "ingoing") ||
                (_this.propertyData.verifyStatus == "pass" &&
                  _this.rkType == "purchasing")
              ) {
                if (_this.clientType == "android") {
                  window.android.getInfo(117);
                } else {
                  window.webkit.messageHandlers.showRkBtn.postMessage(null);
                }
              }
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          _this.$toast("网络失败，请稍后重试");
        });
    },
    deliveryPicker(index) {
      if (this.editType) {
        this.checkIndex = index;
        this.showTimePicker = true;
      }
    },
    onTimeConfirm(data) {
      // console.log(dateTimeFormat(data));
      this.showTimePicker = false;
      this.$set(
        this.goodsList[this.checkIndex],
        "purchaseDate",
        dateFormat(data)
      );
    },
    delect(index) {
      //删除采购单品
      this.goodsList.splice(index, 1);
    },
    delApply() {
      let _this = this;
      let text = this.propertyData.verifyStatus == "hold" ? "删除" : "撤回";
      this.$dialog
        .alert({
          title: text,
          message: "你确定" + text + "吗?",
        })
        .then(() => {
          _this.btnLoading = true;
          _this.$api.material.procurementManage
            .deleteRecall(this.propertyData.verifyStatus, _this.propertyData.id)
            .then((res) => {
              if (res.code == "1") {
                let msg = text + "成功";
                closePage(msg);
              } else {
                _this.$toast(res.msg);
              }
              _this.btnLoading = false;
            })
            .catch((err) => {
              console.log(err);
              _this.btnLoading = false;
              _this.$toast("网络失败，请稍后重试");
            });
        });
    },
    editPage() {
      //需要编辑
      this.editType = true;
    },
    verifyPage() {
      //审批弹窗
      this.verifyPageType = true;
    },
    getJumpUrl() {
      let Url = window.location.protocol + "//" + window.location.host + "";
      let timestamp = Date.parse(new Date());
      let token = this.$route.query.token;
      let orgId = this.$route.query.orgId;
      Url =
        Url +
        "/OA-pageH5/#/addSupplies?token=" +
        token +
        "&commonId=" +
        this.commonId +
        "&commonType=jumpType&orgId=" +
        orgId;
      if (this.clientType == "android") {
        window.android.getInfo(112, Url);
      } else {
        //IOS
        console.log(Url);
        window.webkit.messageHandlers.getJumpUrl.postMessage(Url);
      }
    },
    validate() {
      //校验
      let _this = this;

      if (this.propertyData.reason == "") {
        _this.$toast("请完善表单信息");
        return false;
      }
      if (_this.goodsList > 0) {
        for (var i = 0; i < _this.goodsList.length; i++)
          if (
            _this.goodsList[i].materialName == "" ||
            _this.goodsList[i].price == "" ||
            _this.goodsList[i].purchaseAmount == "" ||
            _this.goodsList[i].unit == ""
          ) {
            _this.$toast("请完善表单信息");
            return false;
          }
      }
      return true;
    },
    checkInput() {
      //确定
      let _this = this;
      if (this.validate()) {
        let params = _this.propertyData;
        _this.$set(params, "itemList", _this.goodsList);
        _this.$set(params, "allMoney", _this.totalMoney.toFixed(2));
        console.log(params);
        _this.btnLoading = true;
        _this.$api.material.procurementManage
          .addEditProcurement(this.mode, params)
          .then((res) => {
            if (res.code == "1") {
              let text = this.mode == "add" ? "添加成功" : "编辑成功";
              closePage(text);
            } else {
              _this.$toast(res.msg);
            }
            _this.btnLoading = false;
          })
          .catch((err) => {
            console.log(err);
            _this.btnLoading = false;
            _this.$toast("网络失败，请稍后重试");
          });
      }
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"]),
    totalMoney() {
      let _this = this,
        num = 0;
      if (_this.goodsList && _this.goodsList[0]) {
        _this.goodsList.forEach((item) => {
          if (Number(item.price) > 0 && Number(item.purchaseAmount) > 0)
            num += parseFloat(item.price) * parseFloat(item.purchaseAmount);
        });
      }

      return num;
    },
  },
};
</script>
<style lang="less">
.procurementPage {
  width: 100%;
  height: 100%;
  background-color: #fff;
  .baseNone {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }
  .baseNone.beizhu {
    min-height: 45px;
  }

  .btnBox {
    width: 100%;
    padding: 0 14px;
    height: 65px;
    position: fixed;
    left: 0;
    bottom: 0;
    padding-top: 10px;
    z-index: 1009;
    background-color: #fff;
    button {
      width: 100%;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      span {
        line-height: 45px;
      }
    }
  }
  .goodsBox {
    width: 100%;
    padding-bottom: 10px;
    .goodsLists {
      width: 95%;
      margin: 0 auto;
      min-height: 140px;
    }
    .addBtn {
      margin-top: 10px;
      width: 100%;
      .addClaim {
        display: block;
        margin: 0 auto;
        border-radius: 8px;
        -webkit-border-radius: 8px;
        -moz-border-radius: 8px;
      }
    }
  }
  .goodsItem {
    margin-top: 10px;
    border: 1px solid #f1f1f1;
    border-radius: 4px;
    position: relative;
    .baseNone::after {
      content: none;
    }
    .baseNone {
      .ggInput {
        border-bottom: 1px solid #ebedf0;
      }
    }
    .delect {
      text-align: center;
      position: absolute;
      top: -6px;
      right: -4px;
      width: 20px;
      height: 20px;
      line-height: 20px;
      border-radius: 50%;
      background: #fff;
      border: 1px solid red;
      color: red;
      cursor: pointer;
      padding-top: 1px;
    }
  }
  //审批记录样式
  .approveList {
    margin-top: 10px;
  }
  //流程图样式
  .flowList {
    margin-top: 10px;
  }
}
</style>